import { Capacitor, registerPlugin, SystemBars, SystemBarsStyle, SystemBarType } from '@capacitor/core';

const navigationBar = registerPlugin<{
  setVisible(options: { visible: boolean }): Promise<void>;
}>('NavigationBarBackground');

// Serialize mount/unmount changes so leaving a page always restores the bar.
let pending = Promise.resolve();

export function setAndroidNavigationMenuVisible(visible: boolean): void {
  if (Capacitor.getPlatform() !== 'android') return;

  pending = pending.then(async () => {
    await SystemBars.setStyle({
      bar: SystemBarType.NavigationBar,
      style: visible ? SystemBarsStyle.Dark : SystemBarsStyle.Default,
    });
    await navigationBar.setVisible({ visible });
  }).catch((error) => {
    console.warn('Could not update Android navigation bar', error);
  });
}
